import React, { useContext, useState } from 'react';
import { Button } from 'antd';

import AddEditDialog from '@totem/components/portfolio/buildings/common/AddEditDialog';
import { getNewBuildingData } from '@totem/components/portfolio/buildings/common/types';
import BuildingSummaryContext from '@totem/components/portfolio/buildings/list/buildingSummary/buildingSummaryContext';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const AddBuildingButton = () => {
  const { userProfile } = useContext(UserProfileContext);
  const [open, setOpen] = useState<boolean>(false);
  const { loading, onAction } = useContext(BuildingSummaryContext);
  const isDisabled =
    !permissions.organizationalAdministrator.hasPermissions(userProfile);

  const handleCloseDialog = (refresh: boolean) => {
    setOpen(false);
    if (refresh) {
      onAction('refresh');
    }
  };

  return (
    <>
      <Button type="primary" onClick={() => setOpen(true)}>
        Add Building
      </Button>
      {open && !isDisabled && (
        <AddEditDialog
          open={open}
          loading={loading}
          buildingData={getNewBuildingData()}
          onClose={handleCloseDialog}
        />
      )}
    </>
  );
};

export default AddBuildingButton;
